import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiPhone, FiMail } = FiIcons;
const { FaFacebookF, FaTwitter, FaInstagram } = FaIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-slate-200 pt-24 pb-12 border-t border-primary-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
          <div className="space-y-8">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-accent-600 rounded-xl flex items-center justify-center shadow-lg shadow-accent-600/20">
                <span className="text-white font-bold text-xl">S</span>
              </div>
              <p className="text-white text-xl font-bold font-poppins tracking-tight">Smart Medical Research</p>
            </div>
            <p className="text-base leading-relaxed text-slate-300 font-poppins">
              Leading the way in clinical research excellence in Jackson Heights, NYC. Dedicated to patient safety and medical innovation.
            </p>
            <div className="flex gap-5">
              <a href="https://www.facebook.com/smartmedresearch" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-2xl bg-primary-800 flex items-center justify-center hover:bg-accent-600 transition-all duration-300 group shadow-lg border border-primary-700">
                <SafeIcon icon={FaFacebookF} className="w-5 h-5 text-slate-300 group-hover:text-white transition-colors" />
              </a>
              
              <a href="https://www.instagram.com/smartmedicalresearch" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-2xl bg-primary-800 flex items-center justify-center hover:bg-accent-600 transition-all duration-300 group shadow-lg border border-primary-700">
                <SafeIcon icon={FaInstagram} className="w-5 h-5 text-slate-300 group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>

          <div>
            <h2 className="text-white font-bold mb-8 font-poppins text-lg relative inline-block">
              Contact Details
              <span className="absolute -bottom-2 left-0 w-8 h-1 bg-accent-500 rounded-full"></span>
            </h2>
            <ul className="space-y-6 text-base font-poppins">
              <li className="flex items-start gap-4 group">
                <div className="w-10 h-10 rounded-xl bg-primary-800 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-600 transition-colors border border-primary-700">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-accent-500 group-hover:text-white transition-colors" />
                </div>
                <span className="text-slate-300 group-hover:text-white transition-colors">37-51 75th Street, Jackson Heights, NY 11372</span>
              </li>
              <li className="flex items-center gap-4 group">
                <div className="w-10 h-10 rounded-xl bg-primary-800 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-600 transition-colors border border-primary-700">
                  <SafeIcon icon={FiPhone} className="w-5 h-5 text-accent-500 group-hover:text-white transition-colors" />
                </div>
                <a href="tel:+19175632011" className="text-slate-300 hover:text-accent-400 transition-colors">+1 (917) 563-2011</a>
              </li>
              <li className="flex items-center gap-4 group">
                <div className="w-10 h-10 rounded-xl bg-primary-800 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-600 transition-colors border border-primary-700">
                  <SafeIcon icon={FiMail} className="w-5 h-5 text-accent-500 group-hover:text-white transition-colors" />
                </div>
                <a href="mailto:info@smartmedicalresearch.com" className="text-slate-300 hover:text-accent-400 transition-colors">info@smartmedicalresearch.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-primary-800 flex flex-col items-center">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-10">
            <Link to="/privacy-policy" className="text-sm text-slate-400 hover:text-accent-400 transition-colors font-poppins">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-sm text-slate-400 hover:text-accent-400 transition-colors font-poppins">Terms of Use</Link>
            <Link to="/cookie-policy" className="text-sm text-slate-400 hover:text-accent-400 transition-colors font-poppins">Cookie Policy</Link>
            <Link to="/accessibility-policy" className="text-sm text-slate-400 hover:text-accent-400 transition-colors font-poppins">Accessibility</Link>
            <Link to="/privacy-hipaa" className="text-sm text-slate-400 hover:text-accent-400 transition-colors font-poppins">HIPAA Notice</Link>
            <Link to="/clinical-study-disclaimers" className="text-sm text-slate-400 hover:text-accent-400 transition-colors font-poppins">Disclaimers</Link>
          </div>
          
          <div className="text-center space-y-3">
            <p className="text-slate-400 text-sm font-poppins tracking-wide">
              &copy; {currentYear} Smart Medical Research. All rights reserved.
            </p>
            <p className="text-slate-500 text-xs font-poppins">
              Built with precision by <a href="https://mobilefirstpro.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-accent-500 transition-colors font-semibold">Mobile First Pro</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;